import React from 'react';
import { FC } from 'react';

export const VarFun: FC = () => {
    return (
        <div>
            <div> 
                <iframe title="Slide" src="https://docs.google.com/presentation/d/e/2PACX-1vQFbrtXDs9Q6znneDj2uLQvXRkeRmzoJ1-pon9YDtB5QiYSaNp50lQD2u90VqglLCnzkwwaYNke9eef/embed?start=false&loop=false&delayms=60000"
                 width="1200" height="675"></iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};
